var _excluded = ["saveButton", "closeButton", "onSubmit", "children", "saveButtonProps", "closeButtonProps", "saveButtonText", "closeButtonText", "style", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import Button from "../button/Button";
import { Save, Cancel } from "../../icons";
import { Context } from "./Modal";
var ModalFooter = function ModalFooter(_ref) {
  var _ref$saveButton = _ref.saveButton,
    saveButton = _ref$saveButton === void 0 ? false : _ref$saveButton,
    _ref$closeButton = _ref.closeButton,
    closeButton = _ref$closeButton === void 0 ? false : _ref$closeButton,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? undefined : _ref$children,
    _ref$saveButtonProps = _ref.saveButtonProps,
    saveButtonProps = _ref$saveButtonProps === void 0 ? {} : _ref$saveButtonProps,
    _ref$closeButtonProps = _ref.closeButtonProps,
    closeButtonProps = _ref$closeButtonProps === void 0 ? {} : _ref$closeButtonProps,
    _ref$saveButtonText = _ref.saveButtonText,
    saveButtonText = _ref$saveButtonText === void 0 ? "Save" : _ref$saveButtonText,
    _ref$closeButtonText = _ref.closeButtonText,
    closeButtonText = _ref$closeButtonText === void 0 ? "Cancel" : _ref$closeButtonText,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(Context);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: "tui-modal-footer ".concat(className),
    style: style
  }), children, saveButton && /*#__PURE__*/React.createElement(Button, _extends({
    variant: "confirm",
    icon: {
      type: "left",
      render: function render() {
        return /*#__PURE__*/React.createElement(Save, null);
      }
    },
    onClick: onSubmit,
    className: "save",
    disabled: context.isLoading,
    isLoading: context.isSubmitting
  }, saveButtonProps), saveButtonText), closeButton && /*#__PURE__*/React.createElement(Button, _extends({
    variant: "destructive",
    outline: true,
    icon: {
      type: "left",
      render: function render() {
        return /*#__PURE__*/React.createElement(Cancel, null);
      }
    },
    className: "cancel",
    onClick: context.onCancel,
    disabled: context.isLoading || context.isSubmitting
  }, closeButtonProps), closeButtonText));
};
ModalFooter.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  saveButton: PropTypes.bool,
  closeButton: PropTypes.bool,
  children: PropTypes.node,
  onSubmit: PropTypes.func,
  saveButtonProps: PropTypes.object,
  closeButtonProps: PropTypes.object,
  saveButtonText: PropTypes.string,
  closeButtonText: PropTypes.string
};
export default ModalFooter;
//# sourceMappingURL=ModalFooter.js.map